import Immutable from 'immutable';
import {languages} from 'locale';

export const languageOptions = Immutable.fromJS([
    {label: 'Autodetect', value: 'autodetect'},
].concat(languages));

export const themeOptions = Immutable.fromJS([
    {label: 'Blue', value: 'blue'},
    {label: 'Dark', value: 'dark'},
    {label: 'Light', value: 'light'},
    {label: 'Green', value: 'green'},
    {label: 'Dark Green', value: 'dark-green'},
    {label: 'Red', value: 'red'},
    {label: 'Orange', value: 'orange'},
    {label: 'Turquoise', value: 'turquoise'},
    {label: 'Accessible', value: 'accessible'},
]);

export const searchPositionOptions = Immutable.fromJS([
    {label: 'Above video', value: 'above'},
    {label: 'Below video', value: 'below'},
]);

export const videoSizeOptions = Immutable.fromJS([
    {label: 'Tiny (320px)', value: 320},
    {label: 'Small (360px)', value: 360},
    {label: 'Normal (560px)', value: 560},
    {label: 'Big (720px)', value: 720},
]);

export const containerWidthOptions = Immutable.fromJS([
    {label: 'Tiny (320px)', value: 320},
    {label: 'Small (360px)', value: 360},
    {label: 'Normal (560px)', value: 560},
    {label: 'Big (720px)', value: 720},
]);

export const containerHeightOptions = Immutable.fromJS([
    {label: 'Small (360px)', value: 360},
    {label: 'Normal (560px)', value: 560},
    {label: 'Big (720px)', value: 720},
]);

export const bodyBackgroundOptions = Immutable.fromJS([
    {label: 'Gray', value: '#EFEFEF'},
    {label: 'White', value: '#FFFFFF'},
]);



// WEBPACK FOOTER //
// ./scripts/test-page/options.js